import { render, staticRenderFns } from "./TouchpointStatisticsDetails.vue?vue&type=template&id=fc52fee8&scoped=true&"
import script from "./TouchpointStatisticsDetails.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsDetails.vue?vue&type=script&lang=js&"
import style0 from "../../../../Style/touchpoint-statistics-details.scss?vue&type=style&index=0&id=fc52fee8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc52fee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc52fee8')) {
      api.createRecord('fc52fee8', component.options)
    } else {
      api.reload('fc52fee8', component.options)
    }
    module.hot.accept("./TouchpointStatisticsDetails.vue?vue&type=template&id=fc52fee8&scoped=true&", function () {
      api.rerender('fc52fee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/Statistics/TouchpointStatisticsDetails.vue"
export default component.exports